import { render, staticRenderFns } from "./ChangeLiveCom.vue?vue&type=template&id=18ee9480&scoped=true"
import script from "./ChangeLiveCom.vue?vue&type=script&lang=js"
export * from "./ChangeLiveCom.vue?vue&type=script&lang=js"
import style0 from "./ChangeLiveCom.vue?vue&type=style&index=0&id=18ee9480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee9480",
  null
  
)

export default component.exports